class BrandsList extends HTMLElement {
  constructor() {
    super();
    this.getHeader = document.querySelector('.site-header');
    this.getFilter = this.querySelector('.brands-list__filter');
    this.letters = this.querySelectorAll('.brands-list__filter-letter');
    this.list = this.querySelector('.brands-list__list');

    this.sticky();
    this.scrollToLetter();

    addEventListener('scroll', () => {
      this.sticky();
      this.scrollToLetter();
    });

    addEventListener('resize', () => {
      this.sticky();
      this.scrollToLetter();
    });
  };

  sticky() {
    const isMobile = window.innerWidth < 1023;
    const headerThreshold = isMobile ? 424 : 680;
    const filterThreshold = isMobile ? 530 : 810;
    
    const headerSticky = window.scrollY > headerThreshold ? 'true' : 'false';
    const filterSticky = window.scrollY > filterThreshold ? 'true' : 'false';
    
    this.getHeader.setAttribute('data-sticky', headerSticky);
    this.getFilter.setAttribute('data-sticky', filterSticky);
  }

  scrollToLetter() {
    this.letters.forEach(item => {
      item.addEventListener('click', () => {
        this.letters.forEach(l => l.removeAttribute('data-active'));
        item.setAttribute('data-active', 'true');
        let letter = item.getAttribute('data-scroll');
        let scrollToElement =
          this.querySelector(`.brands-list__list-item[data-scroll="${letter}"]`);

        const yOffset = -185;
        const y = scrollToElement.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      })
    });

  }
}

customElements.define('brands-list', BrandsList);